import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 0;
  min-width: 100px;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 6px;
  height: 44px;

  .avatar {
    flex-shrink: 0;

    .avatar-button {
      display: flex;
      padding: 0;
      border: 0;
      background: none;
      cursor: pointer;
    }

    img {
      border-radius: 6px 0 0 6px;
      width: 44px;
      height: 44px;
      object-fit: cover;
      display: block;
    }

    &.round {
      img {
        border-radius: 100px;
        width: 44px;
        height: 44px;
      }
    }

    &.icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      background: #6B6B6B;
      border-radius: 6px 0 0 6px;

      img {
        border-radius: 0;
        width: 24px;
        height: 24px;
      }
    }

    &.video {
      min-width: 92px;
      max-width: 92px;
      img {
        object-fit: cover;
        border-radius: 6px;
        width: 92px;
        height: 52px;
      }
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-height: 40px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
    padding: 0 12px 0 8px;

    .title {
      max-height: 22px;
      font-size: 16px;
      padding: 3px 0 3px 2px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .subtitle {
      font-size: 13px;
      color: ${(props) => props.theme.colors.inactive};
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 15px;
    }
  }
`;

export default { Wrapper };
